module.exports = __webpack_public_path__ + "static/media/loyly.0c4c32ea.mp3";